import { UsurpPricingHistogramDataProvider } from 'site-modules/shared/components/inventory/usurp-histogram/usurp-pricing-histogram-data-provider';
import { UsurpSaveSearchDataProvider } from 'site-modules/shared/components/inventory/srp-save-search/usurp-save-search-data-provider';

export const usurpDependencyContextValue = {
  filters: { histogram: { component: UsurpPricingHistogramDataProvider } },
  saveSearch: { component: UsurpSaveSearchDataProvider },
};
